import script from "./Partnership.vue?vue&type=script&setup=true&lang=js"
export * from "./Partnership.vue?vue&type=script&setup=true&lang=js"

import "./Partnership.vue?vue&type=style&index=0&id=56513e77&lang=scss"

const __exports__ = script;

export default __exports__